import https from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BASE_URL = `automation/v3/workflows/form-dependencies`;
const getFormDependencies = (guid, sourceApp, portalId = PortalIdParser.get()) => https.get(`${BASE_URL}/${guid}`, {
  query: {
    portalId,
    platformSourceApps: sourceApp,
    uuid: `${portalId}:${guid}`
  }
});
export default getFormDependencies;